import { Record } from 'immutable';

import { RankingListEntity } from '../components/ranking-list/ranking-list.entity';

export interface IRankingState {
	loading: boolean;
	rankingList: RankingListEntity;
	includePublicProjects: boolean;
}

export const defaults: IRankingState = {
	loading: false,
	rankingList: RankingListEntity.build([]),
	includePublicProjects: false,
};

export const RankingFeatureKey = 'ranking';

export class RankingState extends Record<IRankingState>(defaults) {
	public static key = RankingFeatureKey;

	public setLoading(isLoading: boolean): RankingState {
		return this.set('loading', isLoading);
	}

	public setRankingList(rankingList: RankingListEntity): RankingState {
		return this.set('rankingList', rankingList);
	}

	public toggleIncludePublicProjects(
		includePublicProjects: boolean
	): RankingState {
		return this.set('includePublicProjects', includePublicProjects);
	}
}
